<template>

  <!-- 交易 -->
  <div id="Transaction">
    <!-- 内容区域 -->

    <el-container style="width: 100%;height: 100%;">
          <!-- <el-header>Header</el-header> -->
          <el-main style="padding: 0px;">
            <el-table :data="tableData" style="width: 100%;" :default-sort="{prop: 'date', order: 'descending'}"
                @row-click="SelectLine" empty-text="wait">
                <!-- <el-table-column
                        prop="name"
                        label="currency"
                        sortable
                        width="150">
                        <font color="#DCDCDC">/USDT</font>
                      </el-table-column> -->
                <el-table-column prop="tag" label="currency" sortable filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <!-- :type="scope.row.tag === '家' ? 'primary' : 'success'" -->
                    <!--               <el-tag
                                       disable-transitions>{{scope.row.Gain}}</el-tag> -->
                    <p v-if="scope.row.instId == 'dot-usd-swap'" style="text-align: center;float: left;">
                      DOT
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'fil-usd-swap'" style="text-align: center;float: left;">
                      FIL
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'ltc-usd-swap'" style="text-align: center;float: left;">
                      LTC
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'xrp-usd-swap'" style="text-align: center;float: left;">
                      XRP
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'ada-usd-swap'" style="text-align: center;float: left;">
                      ADA
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'etc-usd-swap'" style="text-align: center;float: left;">
                      ETC
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'btc-usd-swap'" style="text-align: center;float: left;">
                      BTC
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'eth-usd-swap'" style="text-align: center;float: left;">
                      ETH
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'doge-usd-swap'" style="text-align: center;float: left;">
                      DOGE
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>

                    <p v-if="scope.row.instId == 'bch-usd-swap'" style="text-align: center;float: left;">
                      BCH
                      <font color="#DCDCDC" size="1">/USDT</font> 
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="bidPx" label="Price" sortable>
                </el-table-column>
                <el-table-column prop="tag" label="Change" sortable filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <p v-if="scope.row.sH <= 0" style="background-color: #aa2116; border-radius: 5px;text-align: center;">
                       <font color="#ffffff"> {{scope.row.sH}} %</font> 
                    </p>
                    <p v-if="scope.row.sH > 0" style="background-color: #225a1f; border-radius: 5px;text-align: center;">
                       <font color="#ffffff"> {{scope.row.sH}} %</font> 
                    </p>
                  </template>
                </el-table-column>
              </el-table>
              </el-main>
          <el-footer style="padding: 0 0px;background-color: #fff;">
              <BottomNav style="height: 100%; width: 100%;"></BottomNav>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
  import BottomNav from '../Bottom-nav.vue'
  import { lStorage, sStorage } from "@Comm/js/Storage.js"
  export default {
    data() {
      return {
        tableData: []
        // //表格
        // tableData: [{Thao:"ces",mmsi:"123"},{Thao:"ces",mmsi:"123"},{Thao:"ces",mmsi:"123"}],
        // pageIndex: 1,
        // //下拉刷新，上拉加载
        // refreshing: false,
        // loadings: false,
        // loadedall: false
      }
    },
    mounted() {
      this.loadData();
      setInterval(() => { //setInterval换个名字就行了
        // console.log(this.$route.path);
        if (this.$route.path != '/M/Transaction') return;
        this.loadData();
      }, 5 * 1000) //设置时间，这里是5秒
    },
    methods: {
      formatter(row, column) {
        return row.num;
      },
      SelectLine(row, col, event) {
        // console.log(row.instId);
        this.$router.push({
          path: '/M/T_Details',
          query: {
            instId:row.instId
          }
        })
      },
      loadData() {
        const that = this;
		let params = new URLSearchParams();
		params.append('token',sStorage.getItem("token"));
        this.$http.get('/price/PriceList', {
            params
          })
          .then(function(response) {
            // console.log(response.data);
            // that.refreshing = false;
            if (response.data.success || response.data.code == 1) {
              // window.login.$message(response.data.message);
              // var content = response.data.content;
              // that.totalmoney = "$" + content.totalMoney;
              function upData(a, b) {
                if (a.instId == "btc-usd-swap") return -1;
                else if (b.instId == "btc-usd-swap") return 0;
                else if (a.instId == "eth-usd-swap") return -1;
                else if (b.instId == "eth-usd-swap") return 0;
                return 1;

                // return a.id-b.id;
              };
              // console.log(response.data.content.sort(upData));
              that.tableData = response.data.content.sort(upData);
              // that.tableData.add()
              // that.cancelable=false;
              // that.tableData = [{
              //   name: 'BTC',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'ETH',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'BTC',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'ETH',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'BTC',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'ETH',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'BTC',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'ETH',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'BTC',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'ETH',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'BTC',
              //   money: '20215',
              //   num: '+3.38'
              // }, {
              //   name: 'ETH',
              //   money: '20215',
              //   num: '+3.38'
              // }
              // ];
              // that.$message(response.data.message);
            }else if (response.data.code == -1){
              sStorage.clear();
              that.$router.replace("/");
              that.$message.error(response.data.message);
            } else {
              that.$message.error(response.data.message);
            }
          });
      }
    },
    components: {
      BottomNav
    }
  };
</script>

<style>
  @import '../../../Comm/css/CommCSS.css';
  #Transaction .mu-appbar .mu-appbar-title {
    text-align: center;
  }

  #Transaction .is-full-width {
    width: 100%;
  }

  #Transaction .content {
    flex: 1
  }

  #Transaction .container {
    width: 100%;
    height: 70%;
    padding-right: 0px;
    padding-left: 0px;
    /* margin-right: auto; */
    /* margin-left: auto; */
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Transaction/Transaction.vue